import React from "react";

const NotesPageLoggedOutView = () => {
  return (
    <>
      <img
        src="not_authorized.jpg"
        alt="Please log in"
        style={{ height: "30rem" }}
      />
      <br />
      <h3>Please sign up or log in to see your notes.</h3>
    </>
  );
};

export default NotesPageLoggedOutView;
